import { combineReducers } from 'redux';

export const createRootReducer = (routerReducer) => combineReducers({
  router: routerReducer,
});

export default createRootReducer;
